import { startCase } from 'es-toolkit';

export type FormatWeekdayType = 'long' | 'short' | 'narrow';

export const formatWeekday = (
  date: Date,
  type: FormatWeekdayType,
  locale = window.navigator.language
) => startCase(new Intl.DateTimeFormat(locale, { weekday: type }).format(date));
